module.exports = __webpack_public_path__ + "static/img/2_6@2x.5c113e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_6@2x.png
// module id = fGy9
// module chunks = 8